/**
 * Rehype plugin: inside any `.cms-row` (except `.cms-row-images`), gather all
 * non-image children into a single `<div class="cms-row__text">` wrapper.
 * The row then has at most TWO direct children — the image and the text
 * container — so the CSS flex/grid layout always produces a clean two-column
 * result regardless of how many paragraphs the author wrote.
 *
 * Shared by `MarkdownRenderer.jsx` (public pages) and the MDEditor live
 * preview inside `AdminCmsEdit.jsx`.
 */
export function rehypeGroupCmsRowText() {
  const hasClass = (node, name) => {
    const cls = node?.properties?.className;
    if (!cls) return false;
    const arr = Array.isArray(cls) ? cls : String(cls).split(/\s+/);
    return arr.includes(name);
  };
  const containsImg = (n) => {
    if (!n || n.type !== "element") return false;
    if (n.tagName === "img") return true;
    return (n.children || []).some(containsImg);
  };
  const walk = (node) => {
    if (!node) return;
    if (
      node.type === "element" &&
      node.tagName === "div" &&
      hasClass(node, "cms-row") &&
      !hasClass(node, "cms-row-images")
    ) {
      const imageChildren = [];
      const textChildren = [];
      for (const child of node.children || []) {
        if (child.type === "text" && /^\s*$/.test(child.value)) continue;
        if (containsImg(child)) imageChildren.push(child);
        else textChildren.push(child);
      }
      if (textChildren.length > 0) {
        node.children = [
          ...imageChildren,
          {
            type: "element",
            tagName: "div",
            properties: { className: ["cms-row__text"] },
            children: textChildren,
          },
        ];
      }
    }
    for (const child of node.children || []) walk(child);
  };
  return (tree) => walk(tree);
}
